<ix-content-header
    variant="Secondary"
    headerTitle="Edit Train Crew Parameters"
    headerSubtitle="Modify the data as required">
</ix-content-header>

<app-generic-header-editor
    [header]="crmtFile?.header">
</app-generic-header-editor>

<ag-grid-angular
    class="ag-theme-alpine-dark ag-theme-ix"
    [columnDefs]="columnDefs"
    [rowData]="rowData"
    [rowSelection]="'single'"
    [animateRows]="true"
    [editType]="'fullRow'"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    [domLayout]="domLayout"
    [pagination]="pagination"
    [paginationPageSize]="paginationPageSize"
    (rowSelected)="onRowSelected($event)"
    (cellValueChanged)="onCellValueChanged($event)">
</ag-grid-angular>

<div class="wrapper">
    <ix-button
        [disabled]="disableEditing"
        class="m-1" 
        variant="primary" 
        (click)="editRow()">
        Edit Row
    </ix-button>
</div>